import { FC } from 'react';

import { DateRangeType } from '../../types/phlebotomist-dashboard';
import styles from '../OperationsDashboard/ops-theme.module.css';

const PERIOD_LABELS: Partial<Record<DateRangeType, string>> = {
  yesterdayCal: 'Yesterday',
  lastWeekCal: 'Last Week',
  lastMonthCal: 'Last Month',
  lastQuarterCal: 'Last Quarter',
  pYearCal: 'Last Year',
  custom: 'Custom',
};

interface IOpsRecruiterHeaderProps {
  regionCode?: string;
  regionLocation?: string;
  partnerLocationCount: number;
  totalLocationCount: number;
  flagsActiveCount: number;
  flagsUpCount: number;
  flagsWarnCount: number;
  flagsDownCount: number;
  periodValue: DateRangeType;
}

const OpsRecruiterHeader: FC<IOpsRecruiterHeaderProps> = ({
  regionCode,
  regionLocation,
  partnerLocationCount,
  totalLocationCount,
  flagsActiveCount,
  flagsUpCount,
  flagsWarnCount,
  flagsDownCount,
  periodValue,
}) => {
  const periodLabel = PERIOD_LABELS[periodValue] || periodValue;

  return (
    <div className={styles.recruiterHeader}>
      <div className={styles.recruiterHeaderRow1}>
        <span className={styles.recruiterHeaderCode}>
          {regionCode || 'All Regions'}
        </span>
        <span className={styles.recruiterHeaderName}>
          {regionLocation || 'United States'}
        </span>
      </div>
      <div className={styles.recruiterHeaderRow2}>
        <span className={styles.recruiterBadge}>
          <span className={styles.recruiterBadgeCount}>
            {partnerLocationCount}
          </span>{' '}
          Active Partner Locations
          <span className={styles.recruiterBadgeSub}>
            Out of {totalLocationCount} Locations
          </span>
        </span>
        <span
          className={`${styles.recruiterBadge} ${styles.recruiterBadgeActive}`}
        >
          <span className={styles.recruiterBadgeDot} />
          <span className={styles.recruiterBadgeCount}>
            {flagsActiveCount}
          </span>{' '}
          Flags Active
          <span className={styles.recruiterBadgeSub}>
            <span
              className={`${styles.healthFlagDotSm} ${styles.healthFlagDotUp}`}
            />{' '}
            {flagsUpCount}
            <span className={styles.recruiterBadgeDivider}>|</span>
            <span
              className={`${styles.healthFlagDotSm} ${styles.healthFlagDotWarn}`}
            />{' '}
            {flagsWarnCount}
            <span className={styles.recruiterBadgeDivider}>|</span>
            <span
              className={`${styles.healthFlagDotSm} ${styles.healthFlagDotDown}`}
            />{' '}
            {flagsDownCount}
          </span>
        </span>
        <span className={styles.recruiterBadge}>{periodLabel}</span>
      </div>
    </div>
  );
};

export default OpsRecruiterHeader;
